
import { useEffect, useRef, useState } from 'react';

interface Testimonial {
  id: number;
  username: string;
  text: string;
  platform: string;
  likes: string;
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    username: '@mariaa.gzz',
    text: 'Compré el sérum que recomendó Luna y llevo 3 semanas usándolo. Mi piel está INCREÍBLE. Gracias por ser tan honesta ❤️',
    platform: 'TikTok',
    likes: '1.2K',
  },
  {
    id: 2,
    username: '@paula_lifestyle',
    text: 'Por fin alguien que recomienda cosas que de verdad funcionan y no solo por dinero. Se nota que lo prueba todo antes.',
    platform: 'TikTok',
    likes: '847',
  },
  {
    id: 3,
    username: '@cris.home.deco',
    text: 'Las toallas de lino son lo mejor que he comprado este año. Gracias Luna por el descubrimiento 🙏',
    platform: 'TikTok',
    likes: '634',
  },
  {
    id: 4,
    username: '@noe_skincare',
    text: 'Me encanta que diga cuando algo NO le gusta. Eso es transparencia real. La única cuenta en la que confío.',
    platform: 'Instagram',
    likes: '2.1K',
  },
  {
    id: 5,
    username: '@laurabeauty92',
    text: 'El labial nude que recomendó es mi nuevo favorito. Color perfecto para el día a día 💋',
    platform: 'TikTok',
    likes: '523',
  },
  {
    id: 6,
    username: '@andrea.vlc',
    text: 'Llevo siguiendo a Luna desde el principio. Cada cosa que recomienda es un acierto. La vela de soja huele BRUTAL.',
    platform: 'Instagram',
    likes: '389',
  },
];

export default function TestimonialsSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!('IntersectionObserver' in window)) {
      setInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setInView(true);
        }
      },
      { threshold: 0.15 },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  const getPlatformIcon = (platform: string) =>
    platform === 'TikTok' ? 'ri-tiktok-line' : 'ri-instagram-line';

  return (
    <section
      ref={sectionRef}
      className="relative bg-[#FAF9F7] py-16 lg:py-20 px-8 md:px-12 lg:px-[8%] overflow-hidden"
    >
      <div className="relative z-10">
        <div
          className={`mb-10 transition-all duration-700 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <p className="text-[13px] tracking-[0.12em] text-[#A39B92] font-normal mb-3">
            Comentarios reales
          </p>
          <h2 className="text-[clamp(1.8rem,3.5vw,2.6rem)] font-bold text-[#222222] leading-tight tracking-[-0.01em]">
            Lo que dice la gente 💬
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {testimonials.map((item, index) => (
            <div
              key={item.id}
              className={`bg-white rounded-lg p-6 transition-all duration-700 hover:shadow-md hover:-translate-y-0.5 ${
                inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
              style={{ transitionDelay: `${150 + index * 100}ms` }}
            >
              {/* Cabecera */}
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2.5">
                  <div className="w-9 h-9 rounded-full bg-[#F5F0EB] flex items-center justify-center">
                    <i
                      className={`${getPlatformIcon(item.platform)} text-[16px] text-[#222222]`}
                    ></i>
                  </div>
                  <div>
                    <p className="text-[14px] font-medium text-[#222222]">
                      {item.username}
                    </p>
                    <p className="text-[12px] text-[#A39B92]">{item.platform}</p>
                  </div>
                </div>
                <div className="flex items-center gap-1 text-[12px] text-[#A39B92]">
                  <i className="ri-heart-fill text-[#EBCFD4] text-[13px]"></i>
                  <span>{item.likes}</span>
                </div>
              </div>

              {/* Texto */}
              <p className="text-[14px] text-[#3A3A3A] leading-[1.7] font-light">
                &ldquo;{item.text}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
